export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Get in <strong>Touch</strong>
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Ready to start your project? Contact us today for a free consultation and quote
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
              <i className="ri-phone-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Call Us</h3>
            <a href="tel:4057476904" className="text-lg text-white/90 hover:text-white transition-colors">
              405-747-6904
            </a>
            <p className="text-sm text-white/70 mt-2">Mon-Sat: 8am - 6pm</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
              <i className="ri-mail-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Email Us</h3>
            <a href="mailto:info@handymanofstillwater.com" className="text-lg text-white/90 hover:text-white transition-colors break-all">
              info@handymanofstillwater.com
            </a>
            <p className="text-sm text-white/70 mt-2">We'll respond within 24 hours</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
              <i className="ri-map-pin-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Service Area</h3>
            <p className="text-lg text-white/90">
              Stillwater & Surrounding Areas
            </p>
            <p className="text-sm text-white/70 mt-2">Serving Northern Oklahoma</p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex gap-6">
            <a href="#" className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer">
              <i className="ri-facebook-fill text-2xl text-white"></i>
            </a>
            <a href="#" className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer">
              <i className="ri-instagram-line text-2xl text-white"></i>
            </a>
            <a href="#" className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer">
              <i className="ri-twitter-x-line text-2xl text-white"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}